import { Container } from "@mui/material";
import TabContainer, { TabConfig } from "../../../components/TabContainer";
import InternScreensAITextGenerator from "./InternScreensAITextGenerator";

const InternContentGenContainer = ({ brandID }: { brandID: string }) => {
  const tabs: TabConfig[] = [
    {
      title: "Content Generation",
      pathname: "",
      element: () => <InternScreensAITextGenerator brandID={brandID} />,
    },
  ];

  return (
    <Container maxWidth="lg">
      <TabContainer brandID={brandID} tabs={tabs} />
    </Container>
  );
};

export default InternContentGenContainer;
